export const developmentData = [
  {
    title: "Web3 Development Landscape",
    content: [
      {
        type: "heading",
        text: "Building the Decentralized Future"
      },
      {
        type: "paragraph",
        text: "Web3 development encompasses building decentralized applications, smart contracts, and blockchain infrastructure. The field combines traditional software development with blockchain technology, cryptography, and decentralized systems."
      }
    ]
  },
  {
    title: "Malaysian Web3 Development",
    content: [
      {
        type: "heading",
        text: "Local Ecosystem Growth"
      },
      {
        type: "list",
        items: [
          "Government Support: MDEC blockchain initiatives",
          "Education: University blockchain courses and research",
          "Startup Ecosystem: Growing number of Web3 startups",
          "Developer Communities: Active meetups and workshops",
          "Regulatory Framework: Progressive approach to crypto regulation"
        ]
      }
    ]
  },
  {
    title: "International Web3 Development",
    content: [
      {
        type: "heading",
        text: "Global Development Hubs"
      },
      {
        type: "list",
        items: [
          "Silicon Valley: Major tech companies and startups",
          "Berlin: European Web3 development center",
          "Singapore: Asian blockchain hub",
          "Toronto: Growing Canadian Web3 scene",
          "Tel Aviv: Blockchain innovation and security"
        ]
      }
    ]
  },
  {
    title: "Web3 Development Environment",
    content: [
      {
        type: "heading",
        text: "Tools and Technologies"
      },
      {
        type: "list",
        items: [
          "Programming Languages: Solidity, Rust, JavaScript, Go",
          "Development Frameworks: Hardhat, Truffle, Foundry",
          "Testing Tools: Ganache, Waffle, Chai",
          "Frontend Libraries: Web3.js, Ethers.js, Wagmi",
          "Infrastructure: Infura, Alchemy, QuickNode"
        ]
      }
    ]
  },
  {
    title: "Achievements and Success Stories",
    content: [
      {
        type: "heading",
        text: "Notable Developments"
      },
      {
        type: "list",
        items: [
          "DeFi Protocols: Uniswap, Aave, Compound revolutionizing finance",
          "NFT Marketplaces: OpenSea, Blur transforming digital ownership",
          "Layer 2 Solutions: Polygon, Arbitrum solving scalability",
          "Cross-chain Bridges: Enabling interoperability",
          "DAO Governance: New models of organization and decision-making"
        ]
      }
    ]
  },
  {
    title: "Future Development Opportunities",
    content: [
      {
        type: "heading",
        text: "Emerging Areas"
      },
      {
        type: "list",
        items: [
          "Zero-Knowledge Proofs: Privacy-preserving applications",
          "AI + Blockchain: Decentralized machine learning",
          "IoT Integration: Blockchain for Internet of Things",
          "Quantum-Resistant Security: Future-proofing cryptography",
          "Sustainable Blockchain: Energy-efficient consensus mechanisms"
        ]
      }
    ]
  }
];
